export default __webpack_public_path__ + "static/media/027-sweater.8bc75bc0.svg";